interface LocalFallbackResult<T> {
  handled: boolean;
  value?: T;
}

const nowIso = () => new Date().toISOString();
const dateFromNow = (days: number) => new Date(Date.now() + days * 24 * 60 * 60 * 1000).toISOString().split('T')[0]!;
const money = (value: number) => Number(value.toFixed(2));

const paginated = <T>(items: T[]) => ({
  items,
  total: items.length,
  page: 1,
  pageSize: 20,
  hasMore: false,
});

export const localClients = [
  {
    id: 'client-1',
    clientNumber: 'FH-1001',
    firstName: 'Margaret',
    lastName: 'Williams',
    fullName: 'Margaret Williams',
    preferredName: 'Margaret',
    dateOfBirth: '1942-04-14',
    age: 84,
    status: 'ACTIVE',
    primaryPhone: { number: '01493738488', type: 'HOME', canReceiveSMS: false },
    phone: '01493 738488',
    email: 'family.williams@example.com',
    gender: 'FEMALE',
    address: { line1: 'Yarmouth Business Park', street: 'Yarmouth Business Park', city: 'Great Yarmouth', state: 'Norfolk', zip: 'NR31 0LN' },
    primaryAddress: { line1: 'Yarmouth Business Park', line2: 'Suffolk Rd', city: 'Great Yarmouth', state: 'Norfolk', postalCode: 'NR31 0LN' },
    emergencyContacts: [{ id: 'ec-1', name: 'Jhony Williams', relationship: 'Son', phone: { number: '07443145911', type: 'MOBILE', canReceiveSMS: true }, email: 'jhony@family.com', isPrimary: true, canMakeHealthcareDecisions: true }],
    intakeDate: '2026-05-01',
    alertsCount: 1,
    criticalAlerts: 0,
    hasCriticalRisks: false,
    programs: [{ id: 'program-1', name: 'Personal Care' }],
    nextVisit: { date: dateFromNow(0), startTime: '09:00' },
    lastVisitDate: dateFromNow(-1),
    outstandingTasks: 3,
    organizationId: 'org-1',
    createdAt: nowIso(),
    updatedAt: nowIso(),
  },
  {
    id: 'client-2',
    clientNumber: 'FH-1002',
    firstName: 'George',
    lastName: 'Taylor',
    fullName: 'George Taylor',
    preferredName: 'George',
    dateOfBirth: '1938-10-02',
    age: 87,
    status: 'ACTIVE',
    primaryPhone: { number: '01493738499', type: 'HOME', canReceiveSMS: false },
    phone: '01493 738499',
    email: 'family.taylor@example.com',
    gender: 'MALE',
    address: { line1: 'Suffolk Road', street: 'Suffolk Road', city: 'Great Yarmouth', state: 'Norfolk', zip: 'NR31 0LN' },
    primaryAddress: { line1: 'Suffolk Road', city: 'Great Yarmouth', state: 'Norfolk', postalCode: 'NR31 0LN' },
    emergencyContacts: [{ id: 'ec-2', name: 'Andrew Taylor', relationship: 'Son', phone: { number: '07443145912', type: 'MOBILE', canReceiveSMS: true }, email: 'andrew.taylor@example.com', isPrimary: true, canMakeHealthcareDecisions: true }],
    intakeDate: '2026-05-05',
    alertsCount: 2,
    criticalAlerts: 1,
    hasCriticalRisks: true,
    programs: [{ id: 'program-2', name: 'Companionship' }],
    nextVisit: { date: dateFromNow(0), startTime: '13:00' },
    lastVisitDate: dateFromNow(-1),
    outstandingTasks: 1,
    organizationId: 'org-1',
    createdAt: nowIso(),
    updatedAt: nowIso(),
  },
  {
    id: 'client-3',
    clientNumber: 'FH-1003',
    firstName: 'Eileen',
    lastName: 'Cooper',
    fullName: 'Eileen Cooper',
    preferredName: 'Eileen',
    dateOfBirth: '1946-07-21',
    age: 79,
    status: 'ACTIVE',
    primaryPhone: { number: '01493738501', type: 'HOME', canReceiveSMS: false },
    phone: '01493 738501',
    email: 'family.cooper@example.com',
    gender: 'FEMALE',
    address: { line1: 'River View', street: 'River View', city: 'Great Yarmouth', state: 'Norfolk', zip: 'NR31 0LN' },
    primaryAddress: { line1: 'River View', city: 'Great Yarmouth', state: 'Norfolk', postalCode: 'NR31 0LN' },
    emergencyContacts: [{ id: 'ec-3', name: 'Helen Cooper', relationship: 'Daughter', phone: { number: '07443145901', type: 'MOBILE', canReceiveSMS: true }, email: 'helen.cooper@example.com', isPrimary: true, canMakeHealthcareDecisions: true }],
    intakeDate: '2026-05-07',
    alertsCount: 0,
    criticalAlerts: 0,
    hasCriticalRisks: false,
    programs: [{ id: 'program-3', name: 'Dementia Support' }],
    nextVisit: { date: dateFromNow(1), startTime: '10:30' },
    lastVisitDate: dateFromNow(-1),
    outstandingTasks: 2,
    organizationId: 'org-1',
    createdAt: nowIso(),
    updatedAt: nowIso(),
  },
  {
    id: 'client-4',
    clientNumber: 'FH-1004',
    firstName: 'Arthur',
    lastName: 'Bennett',
    fullName: 'Arthur Bennett',
    preferredName: 'Arthur',
    dateOfBirth: '1935-01-30',
    age: 91,
    status: 'ACTIVE',
    primaryPhone: { number: '01493738502', type: 'HOME', canReceiveSMS: false },
    phone: '01493 738502',
    email: 'family.bennett@example.com',
    gender: 'MALE',
    address: { line1: 'North Quay', street: 'North Quay', city: 'Great Yarmouth', state: 'Norfolk', zip: 'NR30 1HE' },
    primaryAddress: { line1: 'North Quay', city: 'Great Yarmouth', state: 'Norfolk', postalCode: 'NR30 1HE' },
    emergencyContacts: [{ id: 'ec-4', name: 'Paul Bennett', relationship: 'Son', phone: { number: '07443145902', type: 'MOBILE', canReceiveSMS: true }, isPrimary: true, canMakeHealthcareDecisions: true }],
    intakeDate: '2026-05-09',
    alertsCount: 1,
    criticalAlerts: 0,
    hasCriticalRisks: false,
    programs: [{ id: 'program-4', name: 'Medication Support' }],
    nextVisit: { date: dateFromNow(2), startTime: '08:30' },
    lastVisitDate: dateFromNow(-2),
    outstandingTasks: 4,
    organizationId: 'org-1',
    createdAt: nowIso(),
    updatedAt: nowIso(),
  },
  {
    id: 'client-5',
    clientNumber: 'FH-1005',
    firstName: 'Rose',
    lastName: 'Hughes',
    fullName: 'Rose Hughes',
    preferredName: 'Rose',
    dateOfBirth: '1940-11-18',
    age: 85,
    status: 'ACTIVE',
    primaryPhone: { number: '01493738503', type: 'HOME', canReceiveSMS: false },
    phone: '01493 738503',
    email: 'family.hughes@example.com',
    gender: 'FEMALE',
    address: { line1: 'Marine Parade', street: 'Marine Parade', city: 'Great Yarmouth', state: 'Norfolk', zip: 'NR30 2EN' },
    primaryAddress: { line1: 'Marine Parade', city: 'Great Yarmouth', state: 'Norfolk', postalCode: 'NR30 2EN' },
    emergencyContacts: [{ id: 'ec-5', name: 'Claire Hughes', relationship: 'Niece', phone: { number: '07443145903', type: 'MOBILE', canReceiveSMS: true }, email: 'claire.hughes@example.com', isPrimary: true, canMakeHealthcareDecisions: false }],
    intakeDate: '2026-05-12',
    alertsCount: 0,
    criticalAlerts: 0,
    hasCriticalRisks: false,
    programs: [{ id: 'program-5', name: 'Meal Preparation' }],
    nextVisit: { date: dateFromNow(1), startTime: '12:00' },
    lastVisitDate: dateFromNow(-1),
    outstandingTasks: 1,
    organizationId: 'org-1',
    createdAt: nowIso(),
    updatedAt: nowIso(),
  },
];

export const localCaregivers = [
  { id: 'caregiver-1', firstName: 'Adrian', lastName: 'Popescu', fullName: 'Adrian Popescu', email: 'AdrianPopescu@carer.com', phone: '07443145811', status: 'ACTIVE', role: 'Care Assistant', roles: ['CAREGIVER'], employeeNumber: 'FH-CG-001', employmentType: 'full_time', complianceStatus: 'COMPLIANT', organizationId: 'org-1', createdAt: nowIso(), updatedAt: nowIso() },
  { id: 'caregiver-2', firstName: 'Daniel', lastName: 'Moore', fullName: 'Daniel Moore', email: 'daniel.moore@fuchsiahomecare.co.uk', phone: '07443145812', status: 'ACTIVE', role: 'Senior Carer', roles: ['CAREGIVER'], employeeNumber: 'FH-CG-002', employmentType: 'part_time', complianceStatus: 'REVIEW_DUE', organizationId: 'org-1', createdAt: nowIso(), updatedAt: nowIso() },
  { id: 'caregiver-3', firstName: 'Amelia', lastName: 'Patel', fullName: 'Amelia Patel', email: 'amelia.patel@fuchsiahomecare.co.uk', phone: '07443145813', status: 'ACTIVE', role: 'Care Assistant', roles: ['CAREGIVER'], employeeNumber: 'FH-CG-003', employmentType: 'full_time', complianceStatus: 'COMPLIANT', organizationId: 'org-1', createdAt: nowIso(), updatedAt: nowIso() },
  { id: 'caregiver-4', firstName: 'Oliver', lastName: 'Reed', fullName: 'Oliver Reed', email: 'oliver.reed@fuchsiahomecare.co.uk', phone: '07443145814', status: 'ACTIVE', role: 'Night Care Assistant', roles: ['CAREGIVER'], employeeNumber: 'FH-CG-004', employmentType: 'part_time', complianceStatus: 'COMPLIANT', organizationId: 'org-1', createdAt: nowIso(), updatedAt: nowIso() },
  { id: 'caregiver-5', firstName: 'Grace', lastName: 'Morgan', fullName: 'Grace Morgan', email: 'grace.morgan@fuchsiahomecare.co.uk', phone: '07443145815', status: 'ACTIVE', role: 'Live-in Carer', roles: ['CAREGIVER'], employeeNumber: 'FH-CG-005', employmentType: 'full_time', complianceStatus: 'COMPLIANT', organizationId: 'org-1', createdAt: nowIso(), updatedAt: nowIso() },
];

export const localVisits = localClients.map((client, index) => {
  const caregiver = localCaregivers[index] ?? localCaregivers[0]!;
  const startTimes = ['09:00', '13:00', '10:30', '08:30', '12:00'];
  const durations = [60, 90, 60, 45, 60];
  const serviceNames = ['Personal Care', 'Companionship', 'Dementia Support', 'Medication Support', 'Meal Preparation'];
  const scheduledDate = dateFromNow(index < 2 ? 0 : index - 1);
  return {
    id: `visit-${index + 1}`,
    organizationId: 'org-1',
    branchId: 'branch-1',
    visitNumber: `VIS-100${index + 1}`,
    visitType: 'REGULAR',
    serviceTypeId: serviceNames[index]!.toLowerCase().replaceAll(' ', '-'),
    serviceTypeName: serviceNames[index]!,
    clientId: client.id,
    clientFirstName: client.firstName,
    clientLastName: client.lastName,
    clientPhone: client.primaryPhone,
    clientName: client.fullName,
    assignedCaregiverId: caregiver.id,
    caregiverName: caregiver.fullName,
    scheduledDate,
    scheduledStartTime: startTimes[index]!,
    scheduledEndTime: startTimes[index]!,
    scheduled_start_time: `${scheduledDate}T${startTimes[index]}:00`,
    scheduled_end_time: `${scheduledDate}T${startTimes[index]}:00`,
    scheduledDuration: durations[index]!,
    timezone: 'Europe/London',
    status: index === 1 ? 'COMPLETED' : index === 4 ? 'IN_PROGRESS' : 'SCHEDULED',
    isUrgent: index === 4,
    isPriority: index === 1 || index === 3,
    requiresSupervision: false,
    serviceType: serviceNames[index]!,
    tasksCompleted: index,
    tasksTotal: 3,
    address: { ...client.primaryAddress, country: 'UK' },
    createdAt: nowIso(),
    updatedAt: nowIso(),
  };
});

export const localEvvRecords = localVisits.map((visit, index) => ({
  id: `evv-${index + 1}`,
  visitId: visit.id,
  caregiverId: visit.assignedCaregiverId,
  clientId: visit.clientId,
  clockInTime: `${visit.scheduledDate}T${visit.scheduledStartTime}:00`,
  clockOutTime: index === 4 ? undefined : `${visit.scheduledDate}T${visit.scheduledEndTime}:00`,
  status: index === 4 ? 'IN_PROGRESS' : index === 1 ? 'VERIFIED' : 'COMPLETED',
  verificationMethod: index % 2 === 0 ? 'GPS' : 'PHONE',
  gpsCoordinates: index % 2 === 0 ? { latitude: 52.5982 + index * 0.01, longitude: 1.728 + index * 0.01 } : undefined,
  totalMinutes: visit.scheduledDuration,
  notes: 'Local EVV record for testing time tracking.',
  createdAt: `${visit.scheduledDate}T${visit.scheduledStartTime}:00`,
  updatedAt: nowIso(),
}));

export const localCarePlans = localClients.map((client, index) => {
  const names = ['Personal Care Plan', 'Companionship Plan', 'Dementia Support Plan', 'Medication Support Plan', 'Nutrition and Meal Support Plan'];
  const priorities = ['MEDIUM', 'LOW', 'HIGH', 'MEDIUM', 'MEDIUM'];
  return {
    id: `care-plan-${index + 1}`,
    planNumber: `CP-100${index + 1}`,
    name: names[index]!,
    clientId: client.id,
    clientName: client.fullName,
    title: names[index]!,
    planType: index === 1 ? 'COMPANION' : 'PERSONAL_CARE',
    status: 'ACTIVE',
    priority: priorities[index]!,
    effectiveDate: '2026-05-01',
    expirationDate: '2026-11-01',
    startDate: '2026-05-01',
    endDate: '2026-11-01',
    goals: [{ id: `goal-${index + 1}`, title: `${client.preferredName} care goal`, description: 'Maintain safe daily routine and independence.', targetDate: '2026-09-01', status: 'IN_PROGRESS', priority: priorities[index]! }],
    interventions: [{ id: `intervention-${index + 1}`, goalId: `goal-${index + 1}`, title: 'Planned home-care visit', description: 'Complete agreed care tasks and record observations.', frequency: index === 0 ? 'Daily' : '3x weekly', duration: localVisits[index]?.scheduledDuration ?? 60, assignedRole: localCaregivers[index]?.role ?? 'Care Assistant' }],
    taskTemplates: [],
    tasks: [],
    estimatedHoursPerWeek: [7, 4.5, 7, 5.25, 5][index]!,
    complianceStatus: 'COMPLIANT',
    organizationId: 'org-1',
    createdAt: nowIso(),
    updatedAt: nowIso(),
  };
});

const localFamilyMember = {
  id: 'family-member-1',
  clientId: 'client-1',
  relationship: 'SON',
  relationshipNote: 'Primary family contact',
  isPrimaryContact: true,
  firstName: 'Jhony',
  lastName: 'Williams',
  email: 'jhony@family.com',
  phoneNumber: '07443145911',
  preferredContactMethod: 'PORTAL',
  portalAccessLevel: 'FULL_ACCESS',
  accessGrantedBy: 'admin-fuchsia-catalin',
  accessGrantedAt: nowIso(),
  accessExpiresAt: null,
  status: 'ACTIVE',
  invitationStatus: 'ACCEPTED',
  invitationSentAt: dateFromNow(-15),
  invitationAcceptedAt: dateFromNow(-14),
  receiveNotifications: true,
  notificationPreferences: {
    emailEnabled: true,
    smsEnabled: true,
    pushEnabled: true,
    visitReminders: true,
    visitCompletedUpdates: true,
    careplanUpdates: true,
    incidentAlerts: true,
    appointmentReminders: true,
    messageNotifications: true,
    digestFrequency: 'IMMEDIATE',
    quietHoursStart: '21:00',
    quietHoursEnd: '07:00',
  },
  lastLoginAt: nowIso(),
  passwordResetRequired: false,
  organizationId: 'org-1',
  branchId: 'branch-1',
  statistics: {
    totalNotifications: 3,
    unreadNotifications: 2,
    totalMessages: 4,
    unreadMessages: 1,
    lastActivityDate: nowIso(),
  },
  createdAt: nowIso(),
  updatedAt: nowIso(),
};

const localFamilyVisits = localVisits.slice(0, 3).map((visit, index) => ({
  id: `family-visit-${index + 1}`,
  visitId: visit.id,
  clientId: visit.clientId,
  familyMemberIds: [localFamilyMember.id],
  scheduledStartTime: `${visit.scheduledDate}T${visit.scheduledStartTime}:00`,
  scheduledEndTime: `${visit.scheduledDate}T${visit.scheduledEndTime}:00`,
  actualStartTime: index === 1 ? `${visit.scheduledDate}T${visit.scheduledStartTime}:00` : undefined,
  actualEndTime: index === 1 ? `${visit.scheduledDate}T${visit.scheduledEndTime}:00` : undefined,
  caregiverName: visit.caregiverName,
  tasksCompleted: [
    { taskId: `family-task-${index}-1`, taskName: 'Medication prompt', category: 'Medication', status: index === 1 ? 'COMPLETED' : 'INCOMPLETE' },
    { taskId: `family-task-${index}-2`, taskName: 'Meal support', category: 'Nutrition', status: index === 1 ? 'COMPLETED' : 'INCOMPLETE' },
  ],
  visitNotes: index === 1 ? 'Margaret was comfortable, had lunch, and completed the planned routine.' : undefined,
  status: visit.status === 'COMPLETED' ? 'COMPLETED' : visit.status === 'IN_PROGRESS' ? 'IN_PROGRESS' : 'SCHEDULED',
  visibleToFamily: true,
  publishedAt: nowIso(),
  viewedByFamily: index === 1,
  viewedAt: index === 1 ? nowIso() : null,
  organizationId: 'org-1',
  branchId: 'branch-1',
  createdAt: nowIso(),
  updatedAt: nowIso(),
}));

const localFamilyActivities = [
  {
    id: 'family-activity-1',
    familyMemberId: localFamilyMember.id,
    clientId: 'client-1',
    activityType: 'VISIT_COMPLETED',
    title: 'Morning visit completed',
    description: 'Adrian completed personal care, medication prompt, and breakfast support.',
    summary: 'Visit completed with no concerns.',
    relatedEntityType: 'VISIT',
    relatedEntityId: 'visit-1',
    performedBy: 'caregiver-1',
    performedByName: 'Adrian Popescu',
    occurredAt: nowIso(),
    iconType: 'visit',
    viewedByFamily: false,
    viewedAt: null,
    organizationId: 'org-1',
    branchId: 'branch-1',
    createdAt: nowIso(),
    updatedAt: nowIso(),
  },
  {
    id: 'family-activity-2',
    familyMemberId: localFamilyMember.id,
    clientId: 'client-1',
    activityType: 'CARE_PLAN_UPDATED',
    title: 'Care plan reviewed',
    description: 'The medication support plan was reviewed and remains active.',
    relatedEntityType: 'CARE_PLAN',
    relatedEntityId: 'care-plan-1',
    performedBy: 'admin-fuchsia-catalin',
    performedByName: 'Badan Catalin',
    occurredAt: dateFromNow(-1),
    iconType: 'care-plan',
    viewedByFamily: true,
    viewedAt: nowIso(),
    organizationId: 'org-1',
    branchId: 'branch-1',
    createdAt: nowIso(),
    updatedAt: nowIso(),
  },
];

const localFamilyNotifications = [
  {
    id: 'family-notification-1',
    familyMemberId: localFamilyMember.id,
    clientId: 'client-1',
    category: 'VISIT',
    priority: 'NORMAL',
    title: 'Visit completed',
    message: 'Adrian completed Margaret Williams morning visit.',
    actionUrl: '/family-portal/activity',
    actionLabel: 'View update',
    relatedEntityType: 'VISIT',
    relatedEntityId: 'visit-1',
    deliveryStatus: 'DELIVERED',
    sentAt: nowIso(),
    deliveredAt: nowIso(),
    readAt: null,
    emailSent: true,
    smsSent: false,
    pushSent: true,
    expiresAt: null,
    organizationId: 'org-1',
    createdAt: nowIso(),
    updatedAt: nowIso(),
  },
  {
    id: 'family-notification-2',
    familyMemberId: localFamilyMember.id,
    clientId: 'client-1',
    category: 'MESSAGE',
    priority: 'NORMAL',
    title: 'New message',
    message: 'A care coordinator sent you an update.',
    actionUrl: '/family-portal/messages/family-thread-1',
    actionLabel: 'Open message',
    relatedEntityType: 'MESSAGE',
    relatedEntityId: 'family-thread-1',
    deliveryStatus: 'DELIVERED',
    sentAt: nowIso(),
    deliveredAt: nowIso(),
    readAt: null,
    emailSent: true,
    smsSent: true,
    pushSent: true,
    expiresAt: null,
    organizationId: 'org-1',
    createdAt: nowIso(),
    updatedAt: nowIso(),
  },
];

const localFamilyThreads = [
  {
    id: 'family-thread-1',
    familyMemberId: localFamilyMember.id,
    clientId: 'client-1',
    subject: 'Weekly care update',
    status: 'OPEN',
    priority: 'NORMAL',
    participants: [localFamilyMember.id, 'admin-fuchsia-catalin', 'caregiver-1'],
    assignedToUserId: 'admin-fuchsia-catalin',
    lastMessageAt: nowIso(),
    messageCount: 2,
    unreadCountFamily: 1,
    unreadCountStaff: 0,
    organizationId: 'org-1',
    branchId: 'branch-1',
    createdAt: dateFromNow(-2),
    updatedAt: nowIso(),
  },
];

const localFamilyMessages = [
  {
    id: 'family-message-1',
    threadId: 'family-thread-1',
    familyMemberId: localFamilyMember.id,
    clientId: 'client-1',
    sentBy: 'admin-fuchsia-catalin',
    senderType: 'STAFF',
    senderName: 'Badan Catalin',
    messageText: 'Margaret is settled today. The morning visit was completed and there were no concerns.',
    attachmentUrls: [],
    status: 'DELIVERED',
    readAt: null,
    readBy: [],
    isInternal: false,
    flaggedForReview: false,
    organizationId: 'org-1',
    createdAt: dateFromNow(-1),
    updatedAt: nowIso(),
  },
  {
    id: 'family-message-2',
    threadId: 'family-thread-1',
    familyMemberId: localFamilyMember.id,
    clientId: 'client-1',
    sentBy: localFamilyMember.id,
    senderType: 'FAMILY',
    senderName: 'Jhony Williams',
    messageText: 'Thank you. Please keep me updated after the evening call.',
    attachmentUrls: [],
    status: 'READ',
    readAt: nowIso(),
    readBy: ['admin-fuchsia-catalin'],
    isInternal: false,
    flaggedForReview: false,
    organizationId: 'org-1',
    createdAt: nowIso(),
    updatedAt: nowIso(),
  },
];

const localFamilyDashboard = {
  client: {
    id: 'client-1',
    name: 'Margaret Williams',
  },
  upcomingVisits: localFamilyVisits,
  recentActivity: localFamilyActivities,
  unreadNotifications: localFamilyNotifications.filter((notification) => !notification.readAt).length,
  unreadMessages: localFamilyThreads.reduce((sum, thread) => sum + thread.unreadCountFamily, 0),
  careTeam: localCaregivers.slice(0, 3).map((caregiver, index) => ({
    id: caregiver.id,
    name: caregiver.fullName,
    role: caregiver.role,
    isPrimary: index === 0,
  })),
  activeCarePlan: {
    id: 'care-plan-1',
    name: 'Personal Care Plan',
    goalsTotal: 4,
    goalsAchieved: 3,
  },
};

const localFamilyAccessSettings = {
  id: 'family-access-1',
  familyMemberId: localFamilyMember.id,
  clientId: localFamilyMember.clientId,
  showVisitUpdates: true,
  showCarePlan: true,
  showHealthUpdates: true,
  showDocuments: true,
  allowMessaging: true,
  receiveVisitNotifications: true,
  visibleDocumentIds: ['care-plan-summary', 'visit-summary', 'communication-policy', 'health-update-policy'],
  restrictedData: ['internal staff notes', 'payroll', 'private safeguarding investigations', 'admin-only records'],
  updatedBy: 'owner-marius-dorobat',
  updatedAt: nowIso(),
};

const localFamilyAcknowledgements: Array<{
  id: string;
  familyMemberId: string;
  clientId: string;
  itemId: string;
  label: string;
  itemType: string;
  acknowledgedAt: string;
}> = [];

export const localTasks = localClients.map((client, index) => ({
  id: `task-${index + 1}`,
  carePlanId: `care-plan-${index + 1}`,
  clientId: client.id,
  title: ['Morning medication reminder', 'Companionship walk', 'Hydration and orientation prompts', 'Morning medication documentation', 'Lunch preparation and fridge check'][index]!,
  name: ['Morning medication reminder', 'Companionship walk', 'Hydration and orientation prompts', 'Morning medication documentation', 'Lunch preparation and fridge check'][index]!,
  description: 'Fictive task for testing the workflow with complete data.',
  status: ['SCHEDULED', 'SCHEDULED', 'IN_PROGRESS', 'SCHEDULED', 'COMPLETED'][index]!,
  priority: ['HIGH', 'MEDIUM', 'HIGH', 'HIGH', 'MEDIUM'][index]!,
  category: ['MEDICATION', 'COMPANIONSHIP', 'MONITORING', 'MEDICATION', 'MEAL_PREPARATION'][index]!,
  scheduledDate: dateFromNow(index % 3),
  scheduledTime: `${dateFromNow(index % 3)}T${['09:00', '13:00', '10:30', '08:30', '12:00'][index]}:00`,
  estimatedDuration: [15, 30, 20, 15, 45][index]!,
  assignedCaregiverId: localCaregivers[index]?.id,
  instructions: 'Complete the task and record any changes or concerns.',
  createdAt: nowIso(),
  updatedAt: nowIso(),
}));

export const localMedications = localClients.map((client, index) => ({
  id: `medication-${index + 1}`,
  clientId: client.id,
  medicationName: ['Ramipril', 'Paracetamol', 'Donepezil', 'Atorvastatin', 'Vitamin D3'][index]!,
  genericName: ['Ramipril', 'Paracetamol', 'Donepezil hydrochloride', 'Atorvastatin calcium', 'Colecalciferol'][index]!,
  dosage: ['5 mg', '500 mg', '10 mg', '20 mg', '1000 IU'][index]!,
  route: 'ORAL',
  frequency: ['Once daily', 'As needed, max 4 daily', 'Once nightly', 'Once daily', 'Once daily'][index]!,
  instructions: ['Take with water after breakfast.', 'Record reason before administration.', 'Give at bedtime.', 'Give after evening meal.', 'Give with lunch.'][index]!,
  prescribedBy: ['Dr. James Harris', 'Dr. Olivia Smith', 'Dr. Priya Nair', 'Dr. Thomas Reed', 'Dr. Emma Clarke'][index]!,
  prescribedDate: '2026-04-20',
  startDate: '2026-05-01',
  status: index === 4 ? 'ON_HOLD' : 'ACTIVE',
  refillsRemaining: [3, 1, 2, 4, 0][index]!,
  lastAdministered: `${dateFromNow(-1)}T09:00:00`,
  nextScheduledTime: `${dateFromNow(index === 1 ? -1 : 0)}T18:00:00`,
  sideEffects: index === 2 ? ['Nausea', 'Sleep disturbance'] : [],
  warnings: index === 1 ? ['Check total daily dose'] : index === 4 ? ['Currently on hold pending review'] : [],
  prnProtocol: index === 1 ? 'Only administer for pain or temperature above 38C. Record reason, pain score, dose time, and effect after 60 minutes.' : undefined,
  maxDailyDose: index === 1 ? '4,000 mg in 24 hours' : undefined,
  safetyChecks: index === 1
    ? ['Confirm no other paracetamol-containing product was taken', 'Escalate if pain remains severe after one hour', 'Record body temperature when given for fever']
    : ['Confirm identity and MAR entry before administration', 'Record refusal, missed dose, or side effects immediately'],
}));

export const localInvoices = localClients.map((client, index) => {
  const hours = [7, 6, 8, 5.25, 5][index]!;
  const rates = [60, 52, 58, 55, 50][index]!;
  const total = money(hours * rates);
  const paid = index === 1 ? total : 0;
  return {
    id: `invoice-${index + 1}`,
    invoiceNumber: `INV-100${index + 1}`,
    invoiceType: 'STANDARD',
    clientId: client.id,
    clientName: client.fullName,
    payerId: index === 2 ? 'payer-council' : index === 3 ? 'payer-nhs' : 'payer-private',
    payerType: index === 2 ? 'MEDICAID' : index === 3 ? 'MEDICARE' : 'PRIVATE_PAY',
    payerName: index === 2 ? 'Local Authority' : index === 3 ? 'NHS Continuing Healthcare' : 'Private Pay',
    status: ['SENT', 'PAID', 'PENDING_REVIEW', 'PAST_DUE', 'DRAFT'][index]!,
    periodStart: index === 3 ? '2026-04-16' : '2026-05-01',
    periodEnd: index === 3 ? '2026-04-30' : '2026-05-15',
    invoiceDate: '2026-05-20',
    issueDate: '2026-05-20',
    dueDate: index === 3 ? '2026-05-15' : '2026-06-03',
    lineItems: [{ id: `li-${index + 1}`, billableItemId: `bill-${index + 1}`, serviceDate: '2026-05-14', serviceCode: ['PC60', 'COMP90', 'DEM60', 'MED45', 'MEAL60'][index]!, serviceDescription: localVisits[index]?.serviceTypeName ?? 'Home care visit', providerName: localCaregivers[index]?.fullName, unitType: 'HOUR', units: hours, unitRate: rates, subtotal: total, adjustments: 0, total, clientName: client.fullName, clientId: client.id }],
    subtotal: total,
    taxAmount: 0,
    discountAmount: 0,
    adjustmentAmount: 0,
    totalAmount: total,
    paidAmount: paid,
    balanceDue: money(total - paid),
    createdAt: nowIso(),
    updatedAt: nowIso(),
  };
});

const localReports = [
  { id: 'report-1', reportType: 'EVV_COMPLIANCE', title: 'EVV Compliance Report', description: 'Local operational report for FUCHSIA HOME CARE CATALIN.', organizationId: 'org-1', generatedAt: new Date(), generatedBy: 'Badan Catalin', period: { startDate: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000), endDate: new Date() }, exportFormats: ['PDF', 'EXCEL', 'CSV'], data: {} },
];

const localTeamMembers = [
  { id: 'admin-fuchsia-catalin', firstName: 'Badan', lastName: 'Catalin', email: 'BadanCatalin@admin.com', roles: ['ADMIN'], status: 'ACTIVE', createdAt: nowIso() },
  { id: 'owner-marius-dorobat', firstName: 'Marius', lastName: 'Dorobat', email: 'MariusDorobat@owner.com', roles: ['SUPER_ADMIN'], status: 'ACTIVE', createdAt: nowIso() },
  { id: 'caregiver-1', firstName: 'Adrian', lastName: 'Popescu', email: 'AdrianPopescu@carer.com', roles: ['CAREGIVER'], status: 'ACTIVE', createdAt: nowIso() },
];

const getStoredLocalUser = () => {
  try {
    const raw = globalThis.localStorage?.getItem('auth-storage');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.state?.user ?? null;
  } catch {
    return null;
  }
};

export const localIncidents = [
  { id: 'incident-1', clientId: 'client-1', clientName: 'Margaret Williams', incidentType: 'FALL', severity: 'MEDIUM', status: 'UNDER_REVIEW', occurredAt: `${dateFromNow(-2)}T09:10:00`, discoveredAt: `${dateFromNow(-2)}T09:15:00`, location: 'Client home - hallway', description: 'Client slipped while walking to the kitchen. No hospital attendance required.', reportedBy: 'caregiver-1', reportedByName: 'Adrian Popescu', stateReportingRequired: false, investigationRequired: true, createdAt: nowIso() },
  { id: 'incident-2', clientId: 'client-2', clientName: 'George Taylor', incidentType: 'CLIENT_REFUSAL', severity: 'LOW', status: 'RESOLVED', occurredAt: `${dateFromNow(-3)}T14:20:00`, discoveredAt: `${dateFromNow(-3)}T14:20:00`, location: 'Client home', description: 'Client declined afternoon walk. Family informed and care notes updated.', reportedBy: 'caregiver-2', reportedByName: 'Daniel Moore', stateReportingRequired: false, investigationRequired: false, createdAt: nowIso() },
  { id: 'incident-3', clientId: 'client-3', clientName: 'Eileen Cooper', incidentType: 'MEDICATION_ERROR', severity: 'HIGH', status: 'INVESTIGATION_REQUIRED', occurredAt: `${dateFromNow(-1)}T10:45:00`, discoveredAt: `${dateFromNow(-1)}T11:00:00`, location: 'Client home - lounge', description: 'Medication prompt was delayed. GP and family notified; no adverse effect reported.', reportedBy: 'caregiver-3', reportedByName: 'Amelia Patel', stateReportingRequired: true, investigationRequired: true, createdAt: nowIso() },
  { id: 'incident-4', clientId: 'client-4', clientName: 'Arthur Bennett', incidentType: 'EQUIPMENT_FAILURE', severity: 'MEDIUM', status: 'REPORTED', occurredAt: `${dateFromNow(-4)}T08:40:00`, discoveredAt: `${dateFromNow(-4)}T08:45:00`, location: 'Client home - bedroom', description: 'Bed rail loose during morning visit. Family advised and equipment provider contacted.', reportedBy: 'caregiver-4', reportedByName: 'Oliver Reed', stateReportingRequired: false, investigationRequired: false, createdAt: nowIso() },
  { id: 'incident-5', clientId: 'client-5', clientName: 'Rose Hughes', incidentType: 'INFECTION', severity: 'LOW', status: 'CLOSED', occurredAt: `${dateFromNow(-6)}T12:30:00`, discoveredAt: `${dateFromNow(-6)}T12:35:00`, location: 'Client home - kitchen', description: 'Minor infection-control concern noted and resolved with cleaning protocol.', reportedBy: 'caregiver-5', reportedByName: 'Grace Morgan', stateReportingRequired: false, investigationRequired: false, createdAt: nowIso() },
];

export const localPayPeriods = localCaregivers.map((_, index) => ({
  id: `pay-period-${index + 1}`,
  organizationId: 'org-1',
  periodNumber: 10 + index,
  periodYear: 2026,
  periodType: 'BI_WEEKLY',
  startDate: dateFromNow(-14 - index * 14),
  endDate: dateFromNow(-1 - index * 14),
  payDate: dateFromNow(5 + index),
  status: index === 0 ? 'OPEN' : 'CLOSED',
  totalCaregivers: 5,
  totalHours: 164 + index * 8,
  totalGrossPay: money(2460 + index * 175),
  totalNetPay: money(1985 + index * 140),
  createdAt: nowIso(),
  updatedAt: nowIso(),
}));

export const localPayRuns = localPayPeriods.map((period, index) => ({
  id: `pay-run-${index + 1}`,
  payPeriodId: period.id,
  runNumber: `PR-2026-${String(index + 1).padStart(3, '0')}`,
  runType: 'REGULAR',
  status: index === 0 ? 'PENDING_REVIEW' : 'COMPLETED',
  payPeriodStartDate: period.startDate,
  payPeriodEndDate: period.endDate,
  payDate: period.payDate,
  totalCaregivers: 5,
  totalHours: period.totalHours,
  totalGrossPay: period.totalGrossPay,
  totalDeductions: money(period.totalGrossPay * 0.08),
  totalTaxWithheld: money(period.totalGrossPay * 0.14),
  totalNetPay: period.totalNetPay,
  directDepositCount: 5,
  directDepositAmount: period.totalNetPay,
  checkCount: 0,
  checkAmount: 0,
  hasErrors: false,
  calculatedAt: nowIso(),
  createdAt: nowIso(),
  updatedAt: nowIso(),
}));

export const localPayStubs = localCaregivers.map((caregiver, index) => {
  const gross = money(520 + index * 35);
  const tax = money(gross * 0.18);
  return {
    id: `pay-stub-${index + 1}`,
    payRunId: 'pay-run-1',
    payPeriodId: 'pay-period-1',
    caregiverId: caregiver.id,
    caregiverName: caregiver.fullName,
    caregiverEmployeeId: caregiver.employeeNumber,
    stubNumber: `PS-2026-${String(index + 1).padStart(3, '0')}`,
    payPeriodStartDate: localPayPeriods[0]!.startDate,
    payPeriodEndDate: localPayPeriods[0]!.endDate,
    payDate: localPayPeriods[0]!.payDate,
    regularHours: 30 + index * 2,
    overtimeHours: index === 2 ? 3 : 0,
    doubleTimeHours: 0,
    totalHours: 30 + index * 2 + (index === 2 ? 3 : 0),
    regularPay: gross,
    overtimePay: index === 2 ? 75 : 0,
    doubleTimePay: 0,
    bonuses: index === 4 ? 50 : 0,
    reimbursements: 12,
    currentGrossPay: gross,
    yearToDateGrossPay: money(gross * 9),
    federalIncomeTax: tax,
    stateIncomeTax: 0,
    localIncomeTax: 0,
    socialSecurityTax: money(gross * 0.062),
    medicareTax: money(gross * 0.0145),
    additionalMedicareTax: 0,
    totalTaxWithheld: tax,
    healthInsurance: 0,
    retirement401k: 0,
    otherDeductions: 0,
    totalOtherDeductions: 0,
    currentNetPay: money(gross - tax),
    yearToDateNetPay: money((gross - tax) * 9),
    ytdHours: 270 + index * 18,
    ytdGrossPay: money(gross * 9),
    ytdFederalTax: money(tax * 9),
    ytdStateTax: 0,
    ytdSocialSecurity: money(gross * 0.062 * 9),
    ytdMedicare: money(gross * 0.0145 * 9),
    ytdDeductions: 0,
    ytdNetPay: money((gross - tax) * 9),
    paymentMethod: 'DIRECT_DEPOSIT',
    status: index === 0 ? 'PENDING_APPROVAL' : 'PAID',
    calculatedAt: nowIso(),
    createdAt: nowIso(),
  };
});

const localOpenShifts = localClients.map((client, index) => ({
  id: `open-shift-${index + 1}`,
  visitId: `visit-${index + 1}`,
  clientId: client.id,
  clientName: client.fullName,
  scheduledDate: dateFromNow(index + 1),
  startTime: ['08:30', '10:00', '12:00', '14:00', '17:00'][index]!,
  endTime: ['09:30', '11:30', '13:00', '15:00', '18:30'][index]!,
  duration: [60, 90, 60, 60, 90][index]!,
  timezone: 'Europe/London',
  serviceTypeId: ['personal-care', 'companionship', 'dementia-support', 'medication-support', 'meal-preparation'][index]!,
  serviceTypeName: ['Personal Care', 'Companionship', 'Dementia Support', 'Medication Support', 'Meal Preparation'][index]!,
  requiredSkills: ['moving-handling', 'medication', 'meal-prep'].slice(0, (index % 3) + 1),
  requiredCertifications: ['Care Certificate'],
  address: { line1: client.primaryAddress.line1, city: client.primaryAddress.city, state: client.primaryAddress.state, postalCode: client.primaryAddress.postalCode },
  priority: index === 2 ? 'HIGH' : index === 4 ? 'CRITICAL' : 'NORMAL',
  isUrgent: index === 4,
  fillByDate: dateFromNow(index),
  matchingStatus: index === 0 ? 'NEW' : index === 1 ? 'MATCHED' : index === 2 ? 'PROPOSED' : 'MATCHING',
  matchAttempts: index + 1,
  proposedAssignments: [localCaregivers[index]?.id ?? 'caregiver-1'],
  clientInstructions: 'Use key safe and record arrival notes.',
  internalNotes: 'Local fictitious data for workflow testing.',
  createdAt: nowIso(),
  updatedAt: nowIso(),
}));

const localAuditSummaries = localClients.map((client, index) => ({
  id: `audit-${index + 1}`,
  auditNumber: `AUD-2026-${String(index + 1).padStart(3, '0')}`,
  title: `${client.fullName} care record audit`,
  auditType: index % 2 === 0 ? 'COMPLIANCE' : 'QUALITY',
  status: index === 0 ? 'SCHEDULED' : index === 1 ? 'IN_PROGRESS' : 'COMPLETED',
  priority: index === 2 ? 'HIGH' : 'MEDIUM',
  scheduledStartDate: dateFromNow(index - 2),
  scheduledEndDate: dateFromNow(index + 1),
  leadAuditorName: 'Badan Catalin',
  totalFindings: index,
  criticalFindings: 0,
  complianceScore: 92 + index,
  overallRating: 'GOOD',
}));

export function getLocalApiFallback<T>(url: string, method = 'GET', body?: unknown): LocalFallbackResult<T> {
  if (import.meta.env.VITE_LOCAL_DATA_MODE !== 'true') {
    return { handled: false };
  }

  const path = url.split('?')[0] ?? url;
  const writeOk = { success: true, data: body ?? {}, message: 'Saved locally' };

  if (path === '/api/users/profile') {
    if (method === 'GET') {
      const storedUser = getStoredLocalUser();
      if (storedUser) {
        const [firstName = '', ...lastNameParts] = String(storedUser.name ?? '').split(' ');
        return {
          handled: true,
          value: {
            id: storedUser.id,
            firstName,
            lastName: lastNameParts.join(' '),
            email: storedUser.email,
            organizationId: storedUser.organizationId,
            roles: storedUser.roles,
          } as T,
        };
      }
      return { handled: true, value: { id: 'admin-fuchsia-catalin', firstName: 'Badan', lastName: 'Catalin', email: 'BadanCatalin@admin.com', organizationId: 'org-1', roles: ['ADMIN'] } as T };
    }
    return { handled: true, value: writeOk as T };
  }

  if (path === '/api/users/password' || path === '/api/users/preferences') return { handled: true, value: writeOk as T };
  if (path === '/api/organizations/org-1/users') return { handled: true, value: localTeamMembers as T };
  if (path === '/api/organizations/org-1/invitations') return { handled: true, value: [] as T };

  if (path.match(/^\/api\/family-engagement\/family-members\/[^/]+$/)) {
    if (method === 'PATCH') return { handled: true, value: { ...localFamilyMember, ...(body as object) } as T };
    return { handled: true, value: localFamilyMember as T };
  }
  if (path.match(/^\/api\/family-engagement\/family-members\/[^/]+\/access-settings$/)) {
    if (method === 'PATCH') return { handled: true, value: { ...localFamilyAccessSettings, ...(body as object), updatedAt: nowIso() } as T };
    return { handled: true, value: localFamilyAccessSettings as T };
  }
  if (path.match(/^\/api\/family-engagement\/acknowledgements\/family-member\/[^/]+$/)) {
    if (method === 'POST') {
      const payload = typeof body === 'string' ? JSON.parse(body || '{}') : {};
      const acknowledgement = {
        id: `family-ack-${Date.now()}`,
        familyMemberId: localFamilyMember.id,
        clientId: localFamilyMember.clientId,
        itemId: payload.itemId || 'family-item',
        label: payload.label || 'Family portal item',
        itemType: payload.itemType || 'update',
        acknowledgedAt: nowIso(),
      };
      localFamilyAcknowledgements.unshift(acknowledgement);
      return { handled: true, value: acknowledgement as T };
    }
    return { handled: true, value: localFamilyAcknowledgements as T };
  }
  if (path.match(/^\/api\/family-engagement\/family-members\/[^/]+\/preferences$/)) {
    return { handled: true, value: { ...localFamilyMember, notificationPreferences: { ...localFamilyMember.notificationPreferences, ...(body as object) } } as T };
  }
  if (path.match(/^\/api\/family-engagement\/dashboard\/family-member\/[^/]+$/)) {
    return { handled: true, value: localFamilyDashboard as T };
  }
  if (path.match(/^\/api\/family-engagement\/activity-feed\/family-member\/[^/]+$/)) {
    return { handled: true, value: localFamilyActivities as T };
  }
  if (path.match(/^\/api\/family-engagement\/notifications\/family-member\/[^/]+\/unread$/)) {
    return { handled: true, value: localFamilyNotifications.filter((notification) => !notification.readAt) as T };
  }
  if (path.match(/^\/api\/family-engagement\/notifications\/[^/]+\/read$/)) {
    return { handled: true, value: undefined as T };
  }
  if (path.match(/^\/api\/family-engagement\/messages\/family-member\/[^/]+\/threads$/)) {
    return { handled: true, value: localFamilyThreads as T };
  }
  if (path.match(/^\/api\/family-engagement\/messages\/threads\/[^/]+\/messages$/)) {
    if (method === 'POST') {
      const bodyText = typeof body === 'string' ? JSON.parse(body).messageText : 'New local family message';
      return {
        handled: true,
        value: {
          ...localFamilyMessages[1],
          id: `family-message-${Date.now()}`,
          messageText: bodyText,
          createdAt: nowIso(),
          updatedAt: nowIso(),
        } as T,
      };
    }
    return { handled: true, value: localFamilyMessages as T };
  }
  if (path === '/api/family-engagement/messages/threads' && method === 'POST') {
    return {
      handled: true,
      value: {
        ...localFamilyThreads[0],
        id: `family-thread-${Date.now()}`,
        subject: typeof body === 'string' ? JSON.parse(body).subject : 'New family message',
        lastMessageAt: nowIso(),
        createdAt: nowIso(),
        updatedAt: nowIso(),
      } as T,
    };
  }

  if (path === '/api/compliance/dashboard') {
    return {
      handled: true,
      value: {
        success: true,
        data: {
          deadlineCounts: { overdue: 0, dueSoon: 2, upcoming: 3, current: 18, blocked: 0 },
          caregiverCompliance: { total: 5, compliant: 5, expiring: 0, expired: 0, blocked: 0 },
          authorizationAlerts: [],
          categoryBreakdown: [
            { category: 'CAREGIVER_CREDENTIAL', total: 5, current: 5, dueSoon: 0, overdue: 0, blocked: 0 },
            { category: 'CARE_PLAN_REVIEW', total: 5, current: 3, dueSoon: 2, overdue: 0, blocked: 0 },
            { category: 'CLIENT_AUTHORIZATION', total: 5, current: 5, dueSoon: 0, overdue: 0, blocked: 0 },
          ],
          complianceScore: 94,
          lastScanAt: nowIso(),
        },
      } as T,
    };
  }

  if (path === '/api/compliance/deadlines' || path === '/api/compliance/scan') {
    return {
      handled: true,
      value: {
        success: true,
        data: {
          deadlines: localClients.map((client, index) => ({
            id: `deadline-${index + 1}`,
            title: index % 2 === 0 ? 'Care plan review' : 'Authorization check',
            description: `Review ${client.fullName} documentation and confirm next actions.`,
            category: index % 2 === 0 ? 'CARE_PLAN_REVIEW' : 'CLIENT_AUTHORIZATION',
            priority: index === 2 ? 'HIGH' : 'MEDIUM',
            status: index < 2 ? 'DUE_SOON' : 'UPCOMING',
            entityName: client.fullName,
            deadlineDate: new Date(Date.now() + (index + 4) * 24 * 60 * 60 * 1000).toISOString(),
            actionLabel: index % 2 === 0 ? 'Open care plans' : 'Open client record',
            actionUrl: index % 2 === 0 ? '/care-plans' : '/clients',
          })),
          total: localClients.length,
          scannedAt: nowIso(),
          totalDeadlines: localClients.length,
        },
      } as T,
    };
  }

  if (path.includes('/resolve')) return { handled: true, value: writeOk as T };
  if (path.startsWith('/api/compliance/reports/audit')) return { handled: true, value: { success: true, data: { generatedAt: nowIso(), summary: 'Local compliance audit report', deadlines: [] } } as T };
  if (path === '/api/clients/dashboard') return { handled: true, value: { success: true, data: paginated(localClients) } as T };
  if (path === '/api/clients') {
    if (method === 'GET') return { handled: true, value: { success: true, data: paginated(localClients) } as T };
    return { handled: true, value: { ...localClients[0], ...(body as object), id: `client-${Date.now()}` } as T };
  }
  if (path.match(/^\/api\/clients\/[^/]+\/medications$/)) {
    const clientId = path.split('/')[3];
    return { handled: true, value: localMedications.filter((medication) => medication.clientId === clientId) as T };
  }
  if (path.startsWith('/api/clients/')) {
    const id = path.split('/').pop();
    return { handled: true, value: (localClients.find((client) => client.id === id) ?? localClients[0]) as T };
  }

  if (path.startsWith('/api/caregivers')) return { handled: true, value: { items: localCaregivers, total: localCaregivers.length, page: 1, limit: 20, totalPages: 1 } as T };
  if (path.startsWith('/api/visits/caregivers/availability')) {
    return { handled: true, value: localCaregivers.map((caregiver) => ({ caregiver_id: caregiver.id, first_name: caregiver.firstName, last_name: caregiver.lastName, caregiver_status: caregiver.status, visits: [] })) as T };
  }
  if (path.startsWith('/api/visits')) return { handled: true, value: { success: true, data: localVisits, meta: { startDate: nowIso(), endDate: nowIso(), count: localVisits.length } } as T };
  if (path === '/api/care-plans') return { handled: true, value: paginated(localCarePlans) as T };
  if (path.startsWith('/api/care-plans/')) return { handled: true, value: localCarePlans[0] as T };
  if (path === '/api/tasks') return { handled: true, value: paginated(localTasks) as T };
  if (path.startsWith('/api/tasks/')) return { handled: true, value: localTasks[0] as T };

  if (path === '/api/billing/invoices') return { handled: true, value: { items: localInvoices, invoices: localInvoices, total: localInvoices.length, hasMore: false } as T };
  if (path.startsWith('/api/billing/invoices/')) {
    const id = path.split('/')[4];
    return { handled: true, value: (localInvoices.find((invoice) => invoice.id === id) ?? localInvoices[0]) as T };
  }
  if (path === '/api/billing/summary') {
    return {
      handled: true,
      value: {
        totalInvoiced: money(localInvoices.reduce((sum, invoice) => sum + invoice.totalAmount, 0)),
        totalBilled: money(localInvoices.reduce((sum, invoice) => sum + invoice.totalAmount, 0)),
        totalPaid: money(localInvoices.reduce((sum, invoice) => sum + invoice.paidAmount, 0)),
        totalOutstanding: money(localInvoices.reduce((sum, invoice) => sum + invoice.balanceDue, 0)),
        overdueAmount: money(localInvoices.filter((invoice) => invoice.status === 'PAST_DUE').reduce((sum, invoice) => sum + invoice.balanceDue, 0)),
        invoiceCount: {
          total: localInvoices.length,
          draft: localInvoices.filter((invoice) => invoice.status === 'DRAFT').length,
          pending: localInvoices.filter((invoice) => invoice.status === 'PENDING_REVIEW').length,
          sent: localInvoices.filter((invoice) => invoice.status === 'SENT').length,
          paid: localInvoices.filter((invoice) => invoice.status === 'PAID').length,
          overdue: localInvoices.filter((invoice) => invoice.status === 'PAST_DUE').length,
        },
      } as T,
    };
  }

  if (path.startsWith('/api/evv/')) {
    const id = path.split('/')[3];
    return { handled: true, value: (localEvvRecords.find((record) => record.id === id) ?? localEvvRecords[0]) as T };
  }
  if (path.startsWith('/api/evv')) return { handled: true, value: { items: localEvvRecords, total: localEvvRecords.length, page: 1, pageSize: 20, hasMore: false } as T };
  if (path.startsWith('/api/medications/') && path.endsWith('/administer')) {
    const medicationId = path.split('/')[3];
    const medication = localMedications.find((item) => item.id === medicationId) ?? localMedications[0]!;
    return { handled: true, value: { id: `admin-${Date.now()}`, medicationId, clientId: medication.clientId, administeredBy: 'admin-fuchsia-catalin', administeredAt: nowIso(), dosageGiven: medication.dosage, status: 'GIVEN', notes: 'Marked as administered in local mode.' } as T };
  }
  if (path === '/api/incidents') {
    if (method === 'GET') return { handled: true, value: localIncidents as T };
    return { handled: true, value: { id: `incident-${Date.now()}`, ...(body as object), status: 'REPORTED', createdAt: nowIso() } as T };
  }
  if (path.startsWith('/api/incidents/')) {
    const id = path.split('/').pop();
    return { handled: true, value: (localIncidents.find((incident) => incident.id === id) ?? localIncidents[0]) as T };
  }

  if (path === '/api/payroll/current-period') return { handled: true, value: { data: localPayPeriods[0] } as T };
  if (path === '/api/payroll/summary') {
    return { handled: true, value: { currentPeriod: localPayPeriods[0], upcomingPayDate: localPayPeriods[0]?.payDate, totalEmployees: localCaregivers.length, totalCaregivers: localCaregivers.length, totalHours: localPayPeriods[0]?.totalHours ?? 0, totalGrossPay: localPayPeriods[0]?.totalGrossPay ?? 0, totalTaxWithheld: localPayRuns[0]?.totalTaxWithheld ?? 0, pendingApprovals: 1, recentPayRuns: { total: localPayRuns.length, completed: localPayRuns.filter((run) => run.status === 'COMPLETED').length, failed: 0 }, ytdTotals: { grossPay: 24000, netPay: 19400, taxWithheld: 4200 } } as T };
  }
  if (path === '/api/payroll/periods') return { handled: true, value: { data: localPayPeriods, items: localPayPeriods, total: localPayPeriods.length, hasMore: false } as T };
  if (path.startsWith('/api/payroll/periods/')) {
    const id = path.split('/').pop();
    return { handled: true, value: (localPayPeriods.find((period) => period.id === id) ?? localPayPeriods[0]) as T };
  }
  if (path === '/api/payroll/runs') return { handled: true, value: { items: localPayRuns, total: localPayRuns.length, hasMore: false } as T };
  if (path.startsWith('/api/payroll/runs/')) {
    const id = path.split('/')[4];
    return { handled: true, value: (localPayRuns.find((run) => run.id === id) ?? localPayRuns[0]) as T };
  }
  if (path === '/api/payroll/stubs') return { handled: true, value: { items: localPayStubs, total: localPayStubs.length, hasMore: false } as T };
  if (path.startsWith('/api/payroll/stubs/')) {
    const id = path.split('/')[4];
    return { handled: true, value: (localPayStubs.find((stub) => stub.id === id) ?? localPayStubs[0]) as T };
  }

  if (path === '/api/shift-matching/open-shifts') return { handled: true, value: { items: localOpenShifts, total: localOpenShifts.length, hasMore: false } as T };
  if (path.startsWith('/api/shift-matching/open-shifts/') && path.endsWith('/candidates')) {
    return {
      handled: true,
      value: {
        items: localCaregivers.map((caregiver, index) => ({
          caregiverId: caregiver.id,
          openShiftId: path.split('/')[4],
          caregiverName: caregiver.fullName,
          caregiverPhone: caregiver.phone,
          employmentType: caregiver.employmentType,
          overallScore: 96 - index * 6,
          matchQuality: index < 2 ? 'EXCELLENT' : index < 4 ? 'GOOD' : 'FAIR',
          scores: { skillMatch: 90, availabilityMatch: 95, proximityMatch: 85, preferenceMatch: 80, experienceMatch: 88, reliabilityMatch: 94, complianceMatch: 100, capacityMatch: 90 },
          isEligible: true,
          eligibilityIssues: [],
          distanceFromShift: 2 + index,
          estimatedTravelTime: 8 + index * 3,
          hasConflict: false,
          warnings: [],
          matchReasons: [{ category: 'Continuity', description: 'Good fit for client needs and schedule.', impact: 'POSITIVE' }],
        })),
        total: localCaregivers.length,
      } as T,
    };
  }
  if (path.startsWith('/api/shift-matching/open-shifts/')) {
    const id = path.split('/').pop();
    return { handled: true, value: (localOpenShifts.find((shift) => shift.id === id) ?? localOpenShifts[0]) as T };
  }
  if (path === '/api/shift-matching/metrics') return { handled: true, value: { periodStart: dateFromNow(-30), periodEnd: dateFromNow(0), totalOpenShifts: 5, shiftsMatched: 4, shiftsUnmatched: 1, matchRate: 80, averageMatchScore: 88, averageCandidatesPerShift: 5, averageResponseTimeMinutes: 24, proposalAcceptanceRate: 76, proposalRejectionRate: 12, proposalExpirationRate: 12, excellentMatches: 2, goodMatches: 2, fairMatches: 1, poorMatches: 0, topRejectionReasons: [{ category: 'Unavailable', count: 1 }] } as T };
  if (path.startsWith('/api/shift-matching')) return { handled: true, value: { items: [], total: 0, hasMore: false } as T };

  if (path === '/api/audits/dashboard') {
    return { handled: true, value: { statistics: { totalAudits: 5, auditsByStatus: { SCHEDULED: 1, IN_PROGRESS: 1, FINDINGS_REVIEW: 0, CORRECTIVE_ACTIONS: 0, COMPLETED: 3, APPROVED: 0, ARCHIVED: 0, DRAFT: 0 }, auditsByType: { INTERNAL: 2, EXTERNAL: 0, SAFETY: 0, DOCUMENTATION: 0, FINANCIAL: 0, MEDICATION: 0, INFECTION_CONTROL: 0, TRAINING: 0, QUALITY: 2, COMPLIANCE: 3 }, totalFindings: 5, findingsBySeverity: { LOW: 1, MEDIUM: 1, HIGH: 0, CRITICAL: 0 }, averageComplianceScore: 96, openCorrectiveActions: 1, overdueCorrectiveActions: 0 }, criticalFindings: [], upcomingAudits: localAuditSummaries.filter((audit) => audit.status === 'SCHEDULED'), inProgressAudits: localAuditSummaries.filter((audit) => audit.status === 'IN_PROGRESS'), recentlyCompleted: localAuditSummaries.filter((audit) => audit.status === 'COMPLETED'), overdueCorrectiveActions: [] } as T };
  }
  if (path.startsWith('/api/audits')) return { handled: true, value: { items: localAuditSummaries, total: localAuditSummaries.length, hasMore: false } as T };

  return { handled: false };
}

export const localAnalyticsData = {
  kpis: {
    visits: { scheduled: 18, completed: 14, missed: 0, inProgress: 2, completionRate: 97.4 },
    evvCompliance: { compliantVisits: 14, totalVisits: 15, complianceRate: 0.96, flaggedVisits: 1, pendingReview: 1 },
    revenueMetrics: { billableHours: 126, billedAmount: 6420, paidAmount: 5100, outstandingAR: 1320, averageReimbursementRate: 51 },
    staffing: { activeCaregivers: 5, utilizationRate: 0.82, overtimeHours: 4, credentialExpirations: 0 },
    clientMetrics: { activeClients: 5, newClients: 3, dischargedClients: 0, highRiskClients: 1, overdueAssessments: 0 },
  },
  alerts: [{ type: 'CARE_PLAN_EXPIRING', severity: 'MEDIUM', count: 2, message: 'Two care plans need review this week.', actionRequired: 'Review care plans', affectedEntities: ['Margaret Williams', 'George Taylor'] }],
  revenueTrends: [
    { month: 'Jan', year: 2026, billed: 4200, paid: 3900, outstanding: 300 },
    { month: 'Feb', year: 2026, billed: 5100, paid: 4600, outstanding: 500 },
    { month: 'Mar', year: 2026, billed: 5750, paid: 5200, outstanding: 550 },
    { month: 'Apr', year: 2026, billed: 6100, paid: 5600, outstanding: 500 },
    { month: 'May', year: 2026, billed: 6420, paid: 5100, outstanding: 1320 },
  ],
  caregivers: localCaregivers.map((caregiver, index) => ({ caregiverId: caregiver.id, caregiverName: caregiver.fullName, visitsCompleted: 42 - index * 3, averageVisitDuration: 58, onTimePercentage: 98 - index, evvComplianceRate: 99 - index, clientSatisfactionScore: 4.9 - index * 0.1, noShowRate: 0, geofenceViolations: 0, overtimeHours: index, performanceScore: 97 - index })),
  exceptions: [{ id: 'exception-1', visitId: 'visit-2', caregiverId: 'caregiver-2', caregiverName: 'Daniel Moore', clientId: 'client-2', clientName: 'George Taylor', visitDate: new Date(), exceptionType: 'Manual review', description: 'Visit requires coordinator confirmation.', severity: 'INFO', status: 'UNDER_REVIEW', complianceFlags: ['Review'] }],
  stats: { inProgress: 2, completedToday: 14, upcoming: 6, needsReview: 1 },
  reports: localReports,
};
